import type { Appearance } from './compositor';

// Persist the chosen character appearance. localStorage for now; a backend
// `User.appearance` column can replace this without touching the call sites.
const key = (userKey: string) => 'terraboma:appearance:' + userKey;

export function loadAppearance(userKey: string): Appearance | null {
  try {
    const raw = localStorage.getItem(key(userKey));
    return raw ? (JSON.parse(raw) as Appearance) : null;
  } catch {
    return null;
  }
}

export function saveAppearance(userKey: string, a: Appearance): void {
  try {
    localStorage.setItem(key(userKey), JSON.stringify(a));
  } catch {
    /* storage unavailable — appearance just won't persist */
  }
}
